import { Directive, Injector, Optional } from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, APPLY_STYLES_TYPE, register } from "@wm/components-base";

const DEFAULT_CLS = 'app-card-footer text-muted card-footer';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-card-footer',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmCardFooter]',
  providers: [
  provideAsWidgetRef(CardFooterDirective)
  ],
  standalone: true,
  exportAs: 'wmCardFooter'
})
export class CardFooterDirective extends StylableComponent {
  static initializeProps = register('wm-card-footer');
  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
  }
}

